<template>
	<div v-on:keydown.enter.prevent="applyCoupon" class="separated row gap">
		<input :disabled="couponApplied" class="gap coupon-code" :value="value" @input="updateCode($event.target.value)" placeholder="(case-sensitive)" id="couponCode" type="search" />
		<button class="primary rigid centered apply-code" @click.prevent="applyCoupon" type="button" :disabled="couponApplied">
			<span v-if="processing">
				<i class="fas fa-spinner fa-spin"></i>
			</span>
			<span v-else-if="couponApplied">
				Applied
			</span>
			<span v-else>
				Apply
			</span>
		</button>
	</div>
</template>

<script>
import SubmitButton from '../components/SubmitButton';
import { mapGetters } from 'vuex';


export default {
	name: 'RedeemCodeInput',
	components:{
		SubmitButton
	},
	props: {
		processing: Boolean,
		couponApplied: Boolean,
		value: {
			type: String,
			required: true
		}
	},
	data(){
		return {
			couponCode: ''
		};
	},
	computed:{

	},
	methods:{
		updateCode(code) {
			this.couponCode = code;
		},
		applyCoupon(e) {
			this.$emit('on-submit-code', this.couponCode);
		},
		resetState() {
			this.couponDetails = null;
			this.couponCodeModel = null;
			this.couponDetailsError = null;
			this.subscriptionError = null;
			this.createSubscriptionError = null;
			this.subscribedSuccess = false;
		}
	}

};
</script>

<style scoped>
.page {
	background: #f6f6f6;
	margin-bottom: 0;
}
section > label {
	max-width: 300px;
}
@media only screen and (max-width: 900px) {
	.page {
	    max-width: unset;
	    margin: 0 auto;
	}
}
@media only screen and (max-width: 450px) {
	.redeem.row {
		flex-direction: column-reverse;
    	text-align: center;
	}
	.redeem.row.separated > * + .rigid {
		margin: 1em auto;
	}
	.redeem.row button + button {
		margin-bottom: 1em;
		margin-left: 0;
	}
}

.column.separated-extra > * + .gap,
.column.separated-extra > * + .rigid,
.column.separated-extra > * + .flexible,
.column.separated-extra > * + .fill {
    margin-top: 2em;
}


.bullet-content {
	text-align: left;
	color: #777;
}

.list-item {
	font-size: 18px
}
.list-group .list-item:last-child {
	padding-bottom: 0;
}

.content-narrow .empty h2 {
	margin-bottom: 0;
}

.content-narrow h1 i {
	transform: rotate(-25deg);
	margin-right: 1rem;
}

.content.content-narrow {
	max-width: 400px;
	width: 100%;
	box-sizing: border-box;
}

.content-narrow .panel h2 {
    margin: auto;
    color: #293F52;
	line-height: 1.4rem;
}

h2.centered {
	text-align: center;
}

.content-narrow .panel.empty p {
	margin-top: 1em;
	margin-bottom: 0;
	color: #888;
}

.redeem button {
	width: 100%;
}

.panel + .panel {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	border-top: none;
}

.panel:first-child {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.panel:first-child:last-child {
	border-radius: .5rem;
}

.panel + footer {
	margin-top: 1em;
}



.panel {
	background: white;
	border-radius: 6px;
	padding: 2rem;
	border: 2px solid #dfdfdf;
	width: 100%;
	margin: auto;
	box-sizing: border-box;
}
.dark .panel {
	background: #1a1a1a;
	border: 2px solid #333;
}

.panel footer {
	margin-top: 2em;
}


.apply-code {
	width: 100px;
}

.transparent {
	background: transparent;
}

.notice {
	text-align: left;
}

@media only screen and (max-width : 500px) {
	.panel > .row {
		flex-direction: column;
	}
	.separated.row > button.apply-code {
		margin-left: auto;
	    margin-right: 0;
	    margin-top: .5rem;
	}
}

</style>



// WEBPACK FOOTER //
// ./src/components/RedeemCodeInput.vue